import { ReactComponent as Email } from "assets/images/footer/email.svg";
import { ReactComponent as Facebook } from "assets/images/footer/facebook.svg";
import { ReactComponent as Instagram } from "assets/images/footer/instagram.svg";
//import { ReactComponent as LinkSvg } from "assets/images/footer/link.svg";
import { ReactComponent as Location } from "assets/images/footer/location.svg";
import { ReactComponent as Phone } from "assets/images/footer/phone.svg";
import Container from "components/Container";
import routes from "config/routes";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import s from "./Footer.module.css";

const Telegram = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.891 8.146l-2.003 9.445c-.149.659-.54 0.823-1.091 0.513l-3.053-2.25-1.473 1.417c-.163.163-.3.298-.614.298l.219-3.111 5.662-5.116c.246-.219-.053-.341-.381-.122l-6.997 4.407-3.015-.944c-.655-.205-.667-.655.137-.969l11.785-4.542c.545-.205 1.022.121.82 1.344z" />
  </svg>
);

const WhatsApp = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12.012 2c-5.506 0-9.989 4.478-9.99 9.984a9.964 9.964 0 001.37 5.016l-1.392 5.086 5.204-1.365a9.932 9.932 0 004.805 1.25h.003c5.506 0 9.989-4.478 9.99-9.984a9.96 9.96 0 00-9.99-9.987zm4.98 14.154c-.273.767-1.344 1.39-1.854 1.488-.475.09-1.092.177-3.19-.652-2.684-1.06-4.417-3.784-4.55-3.962-.134-.178-1.085-1.442-1.085-2.75 0-1.309.686-1.954.929-2.221.243-.267.531-.334.708-.334.177 0 .354.002.508.01.161.007.38-.06.594.46.221.536.753 1.838.82 1.97.066.134.11.29.022.467-.088.178-.133.29-.265.445-.133.156-.279.347-.399.467-.134.134-.273.28-.117.547.156.267.69 1.135 1.478 1.834.982.873 1.81 1.144 2.076 1.277.266.134.42.112.576-.067.156-.178.663-.77.841-1.034.178-.266.354-.223.597-.134.244.09 1.55.73 1.815.863.266.134.443.2.509.312.067.112.067.647-.206 1.414z" />
  </svg>
);

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className={s.footerInner}>
        <div className={s.footerSocialSection}>
          <Container>
            <ul className={s.socialList}>
              <li className={s.socialItem}>
                <a
                  href="https://www.facebook.com/login.php?next=https%3A%2F%2Fwww.facebook.com%2FWHOKazakhstan%2Fabout%2F%3Fref%3Dpage_internal"
                  className={s.socLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Facebook className={s.icon} />
                  Facebook
                </a>
              </li>
              <li className={s.socialItem}>
                <a
                  href="https://www.instagram.com/nrchd_kz"
                  className={s.socLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Instagram className={s.icon} />
                  Instagram
                </a>
              </li>
              <li className={s.socialItem}>
                <a
                  href="https://t.me/kulturazdorovyaa"
                  className={s.socLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Telegram className={s.icon} />
                  Telegram
                </a>
              </li>
            </ul>
          </Container>
        </div>
        <div className={s.footerContentSection}>
          <Container>
            <ul className={s.list}>
              <li className={s.itemNav}>
                <div className={s.iconWrapper}>
                  <Link to={routes.home} className={s.link}>
                    {t("Header.navBar.home")}
                  </Link>
                </div>

                <div className={s.iconWrapper}>
                  <Link to={routes.aboutUs} className={s.link}>
                    {t("Header.navBar.about")}
                  </Link>
                </div>
                <div className={s.iconWrapper}>
                  <Link to={routes.socialize} className={s.link}>
                    {t("Header.navBar.socialize")}
                  </Link>
                </div>
                <div className={s.iconWrapper}>
                  <Link to={routes.news} className={s.link}>
                    {t("Header.navBar.news")}
                  </Link>
                </div>
                <div className={s.iconWrapper}>
                  <Link to={routes.healthTopics} className={s.link}>
                    {t("Header.navBar.health")}
                  </Link>
                </div>
                <div className={s.iconWrapper}>
                  <Link to={routes.materialsAndInstructions} className={s.link}>
                    {t("Header.navBar.materials")}
                  </Link>
                </div>
                <div className={s.iconWrapper}>
                  <Link to={routes.SHEsurvey} className={s.link}>
                    {t("Header.navBar.assessment")}
                  </Link>
                </div>
              </li>

              <li className={s.item}>
                <h3 className={s.header}>{t("Footer.health.title")}</h3>
                <div className={s.iconLocationWrapper}>
                  <Location className={s.contactIcon} />
                  <a
                    className={s.link}
                    href="https://goo.gl/maps/#"
                    target="blank"
                  >
                    {t("Footer.health.location1")}
                    <p>{t("Footer.health.location2")}</p>
                  </a>
                </div>
                <div className={s.iconWrapper}>
                  <Phone className={s.contactIcon} />
                  <a className={s.link} href="tel: 87172572950,1101">
                    {t("Footer.health.phone")}
                  </a>
                </div>
                <div className={s.iconWrapper}>
                  <Email className={s.contactIcon} />
                  <a
                    className={s.link}
                    href="mailto:hps.info@nrchd.kz"
                    target="blank"
                  >
                    {t("Footer.health.email")}
                  </a>
                </div>
                <div className={s.iconWrapper}>
                  <WhatsApp className={s.icon} />
                  <a
                    className={s.link}
                    href="https://wa.me/77758836891"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Footer.health.whatsapp", "Техподдержка сайта: +7 (775) 883-68-91")}
                  </a>
                </div>
              </li>
            </ul>
          </Container>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
